import blog1 from "./../../assets/1.jpg";
import blog2 from "./../../assets/2.jpg";

const Data=[
{
 img : blog1,
 title:"Rainbow Vegetable Sandwich",
 time: '15 - 20 Minutes',
 price:'10.50$'

},

{
    img : blog2,
    title:"Fraisier",
    time: '30 - 45 Minutes',
    price:'9.20$'

   },

{
    img : blog1,
    title:"Raspberry Stuffed French Toast",
    time: '20 - 25 Minutes',
    price:'12.50$'
   
   },


]

export default Data;